<template>
    <div class="columns center">
        <div class="table-container center-column">
            <table class="table is-responsive is-fullwidth">
                <thead>
                <tr>
                    <th v-if="!isSalesStaff"></th>
                    <th>#ID</th>
                    <th>Start</th>
                    <th>End</th>
                    <th>Auction</th>
                    <th v-if="!isSalesStaff">Yokohama</th>
                    <th>Yokohama(sales)</th>
                    <th v-if="!isSalesStaff">Nagoya</th>
                    <th>Nagoya(sales)</th>
                    <th v-if="!isSalesStaff">Osaka</th>
                    <th>Osaka(sales)</th>
                    <th v-if="!isSalesStaff">Kobe</th>
                    <th>Kobe(sales)</th>
                    <th v-if="!isSalesStaff">Hakata</th>
                    <th>Hakata(sales)</th>
                    <th>Company</th>
                    <th>Comment</th>
                </tr>
                </thead>
                <tbody>
                    <inland-price-create-table-row v-if="!isSalesStaff"></inland-price-create-table-row>
                    <inland-price-table-row v-for="price in prices" :price="price"></inland-price-table-row>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
    import InlandPriceTableRow from './InlandPriceTableRow.vue'
    import InlandPriceCreateTableRow from './InlandPriceCreateTableRow.vue'
    export default {
        components: {
            InlandPriceTableRow,
            InlandPriceCreateTableRow
        },
        computed: {
            prices () {
                return this.$store.getters.getInlandPrices
            },
            isSalesStaff() {
                if (this.$store.getters.getUserRole === 'Sales Staff') {
                    return true
                }
            }
        },
        created() {
            this.$store.dispatch('fetchAllInlandCompanies')
            this.$store.dispatch('fetchAllInlandPrices')
        }
    }
</script>

<style scoped>
    .table-container {
        padding-top: 20px;
        max-width: 100%;
    }
    .is-responsive-table th {
        font-size: small;
    }
    .long {
        min-width: 75px;
    }
    .link {
        border-bottom: 1px solid blue;
        cursor: pointer;
    }
    .center, .center-column, .top, .right, .bottom, .left {
        justify-content: center;
        align-items: center;
    }
    th {
        font-size: small;
    }
</style>


// WEBPACK FOOTER //
// src/components/ControlPanel/InlandPrices/InlandPriceTable.vue